// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container__page-explore-detail .button__redeem-code.btn-link{text-decoration:underline}.container__page-explore-detail .button__redeem-code.btn-link:hover{text-decoration:none}.skills-tooltip.tooltip.b-tooltip{opacity:1!important}.skills-tooltip .tooltip-inner{background-color:#fff!important;line-height:26px;padding:14px}.col-md-10{max-width:85%}", ""]);
// Exports
module.exports = exports;
